'use client'
import type { FC, ReactNode } from 'react'
import dynamic from 'next/dynamic'
import StyledComponentsRegistry from '@/utils/base/styled-components-registry'
import { ToastProvider, ModalsProvider, SessionProvider, FiltersProvider } from '@/context'

const DynamicModalMenu = dynamic(() => import('@/components/modals/ModalMenu').then(mod => mod.ModalMenu), { ssr: false })

type Props = {
  children: ReactNode
}

const ClientProviders:FC<Props> = ({ children }) => {
  return (
    <StyledComponentsRegistry>
			<ToastProvider>
				<SessionProvider>
					<FiltersProvider>
						<ModalsProvider>
							{children}
							<DynamicModalMenu />
						</ModalsProvider>
					</FiltersProvider>
				</SessionProvider>
			</ToastProvider>
    </StyledComponentsRegistry>
  )
}

export default ClientProviders
